import svg from 'src/assets/pin-no-gps.svg?raw';
import { COLOR_VALUES } from 'src/services/constants';
import SvgMarker from './SvgMarker';

export default class NoGpsSvgMarker extends SvgMarker {
  constructor() {
    super(svg, {
      height: 91,
      width: 60,
      innerColor: COLOR_VALUES.WHITE,
      outerColor: COLOR_VALUES.DARK,
    });
  }
}
